'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import { hasSmokeAlarm } from 'AdsUI/selectors/AuthSelectors';
import UILink from 'UIComponents/link/UILink';
import { getAdAccounts } from 'AdsUI/selectors/AccountsSelectors';
import { Networks } from 'AdsUI/lib/Constants';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';

const LILink = ({
  children
}) => /*#__PURE__*/_jsx(UILink, {
  href: "https://linkedin.statuspage.io/",
  external: true,
  children: children
});

const SmokeAlarm = () => {
  const smokeAlarmEnabled = useSelector(hasSmokeAlarm);
  const adAccounts = useSelector(getAdAccounts);
  const liAccounts = useMemo(() => {
    if (!adAccounts) {
      return 0;
    }

    return adAccounts.filter(adAccount => adAccount.network === Networks.LINKEDIN).size;
  }, [adAccounts]);
  return smokeAlarmEnabled && liAccounts > 0 ? /*#__PURE__*/_jsx(UIAlert, {
    closeable: false,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "smokeAlarm.title"
    }),
    type: "warning",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "smokeAlarm.body_jsx",
      elements: {
        LILink
      }
    })
  }) : null;
};

export default SmokeAlarm;